<template>
  <v-container fluid grid-list-lg class="pa-2">
    <v-layout row wrap>
      <v-flex xs12>
        <v-system-bar color="accent" dark window>
          <v-menu offset-y bottom min-width="300">
            <v-btn slot="activator" flat>Наборы <v-icon>mdi-menu-down</v-icon></v-btn>
            <v-list dense>
              <v-list-tile @click="editSet($event)">Добавить</v-list-tile>
              <v-list-tile v-for="(item, index) in sets" :key="item.id" @click="getSetStatistics(item)" class="set__list-item"
                           :class="{'blue lighten-4':(selectedSet && item.id===selectedSet.id)}">
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.name"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn small icon @click.stop="editSet($event, item)"><v-icon class="mx-0">edit</v-icon></v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn small icon @click.stop="deleteSet(item)"><v-icon class="mx-0">close</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            v-model="menu"
            offset-y
            bottom
            absolute
            :position-x=position.x
            :position-y="position.y"
          >
            <v-card>
              <v-card-text class="py-1">
                <v-text-field label="Название набора" hide-details v-model="currentSet.name" @keypress.enter="saveSet"></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="menu = false" small>Отмена</v-btn>
                <v-btn color="success" dark @click="saveSet" :disabled="!currentSet.name" small>Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu left transition="slide-y-transition" :close-on-content-click="false" :nudge-width="100">
            <v-btn slot="activator" flat v-show="selectedSet">Статистики набора</v-btn>
            <v-card height="300">
              <v-card-text class="pa-1">
                <dantser-tree
                  :source="all_statistics"
                  ref="statisticTree"
                  :selectMode="2"
                  @node-select="selectNode"
                  checkbox
                ></dantser-tree>
              </v-card-text>
              <v-card-actions>
                <v-btn color="success" small @click="addToSet">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-system-bar>
        
        <template v-if="selectedSet && !loading">
          <h1 class="display-1 ma-3 text-xs-center">{{selectedSet.name}}</h1>
          <v-flex xs12 v-if="setStatistics.length===0" class="text-xs-center mt-5">
            <p class="headline">В данном наборе отсутствуют статистики</p>
          </v-flex>
          <v-layout row wrap v-else v-sortable="options">
            <v-flex xs12 lg6 xl4 class="text-xs-center" v-for="(statistic, index) in setStatistics" :key="index">
              <d-statistic :statistic="statistic" :id="statistic.id" ref="chart" with_delete @table-view="tableMode" @delete-stat="deleteFromSet"></d-statistic>
            </v-flex>
          </v-layout>
        </template>
        <v-flex xs12 v-else-if="loading" class="text-xs-center pt-5">
          <p>Загрузка ...</p>
          <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import DStatistic from '../Statistics/Statistic'
  import {mapGetters, mapState} from 'vuex'
  import entities from '@/mixins/entities/old'
  
  export default {
    name : 'Sets',
  
    components:{
      DStatistic
    },
  
    mixins: [entities],
    
    data() {
      return {
        loading: false,
        menu: false,
        currentSet: { name: '', id:''},
        position:{ x: 400, y: 200},
        setStatistics: [],
        selectedSet: null,
        options:{
          handle: '.statistic-edit-btn',
          forceFallback: true,
          onEnd: this.dropStatistic
        },
        all_statistics: [
          {
            id: 1,
            name: 'Мои статистики',
            children: [],
            icon: 'mdi mdi-square',
            unselectable: true,
          },
          {
            id: 2,
            name: 'Доступные мне',
            children: [],
            icon: 'mdi mdi-square',
            unselectable: true
          },
          {
            id: 3,
            name: 'Комплексные статистики',
            children: [],
            icon: 'mdi mdi-square',
            unselectable: true
          },
        ]
      }
    },
    
    computed:{
      ...mapGetters('analytics_old/indicators', ['indicators']),
      ...mapGetters('analytics_old/statistics', ['complex_statistics']),
      ...mapGetters('analytics_old/sets', ['sets']),
      ...mapState(`app/account`, {
        companyId: state => state.companyId
      }),
    },
    
    created(){
      this.$store.dispatch('analytics_old/sets/list').then( response => {
        if(this.sets.length>0) this.getSetStatistics(this.sets[0])
      })
      this.$store.dispatch('analytics_old/indicators/list').then( response => {
        this.all_statistics[0].children = response.my
        this.all_statistics[1].children = response.other
      })
      this.$store.dispatch('analytics_old/statistics/list').then( response => {
        this.all_statistics[2].children = response
      })
    },
    
    
    methods : {
      saveSet(){
        if(!!this.currentSet.id){
          this.$store.dispatch('analytics_old/sets/update', {id: this.currentSet.id, name: this.currentSet.name})
        } else {
          this.$store.dispatch('analytics_old/sets/create', {name: this.currentSet.name})
        }
        this.menu = false
      },
      
      editSet(event, set){
        if( typeof set === 'undefined'){
          set = { name: '', id: ''}
        }
        this.currentSet = {...set}
        this.position = { x: event.x, y: event.y}
        this.menu = true
      },
      
      deleteSet(set){
        this.$store.dispatch('analytics_old/sets/delete', set.id)
      },
  
      getSetStatistics(set){
        this.selectedSet = set
        this.loading = true
        this.$store.dispatch('analytics_old/sets/view', set.id).then( response => {
          this.loading = false
          this.setStatistics = response
  
          this.setStatistics.map( stat => {
            if(stat.lines.length>0) this.convertOutputSettings(stat.lines)
          })
          
          let stat_ids = []
          if(response.length>0){
            response.map(stat=>{
              stat_ids.push(stat.id)
            })
          }
          this.$refs['statisticTree'].setNodesSelected(stat_ids)
        })
      },
      
      deleteFromSet(id){
        const index = this.setStatistics.findIndex( el => el.id === id)
        if(index>-1){
          this.loading = true
          this.$store.dispatch('analytics_old/sets/deleteStatistic', {
            set_id: this.selectedSet.id,
            statistic_id: id,
            type:this.setStatistics[index].type
          }).then( response => {
            this.$refs['statisticTree'].setSelected(id, false)
            this.setStatistics.splice(index,1)
            this.loading = false
          })
        }
      },
  
      tableMode(id){
        let routeData = this.$router.resolve({name: 'analytics.statistics', params: { cid: this.companyId }, query: {id: id}});
        window.open(routeData.href, '_blank');
      },
      
      dropStatistic(e){
        let id = e.item.querySelector('.statistic-container').id
        let position = e.newIndex
        
        this.$store.dispatch('analytics_old/sets/changePosition', {set_id: this.selectedSet.id, statistic_id: id, position: position})
      },
  
      addToSet(){
        let nodes = this.$refs['statisticTree'].getNodesByProp('selected', true)
        this.loading = true
        //Если в массиве выбранных нет каких-либо из тех, что имеются - удалить их
        let i = this.setStatistics.length
        while (i--) {
          if ( nodes.findIndex(node=>node.id===this.setStatistics[i].id)<0 ) {
            this.setStatistics.splice(i, 1)
          }
        }
        let statistics_ids = []
        
        nodes.map(item => {
          if(item.element_type==='statistic' || item.element_type==='complex_statistic'){
            let type = (item.element_type.indexOf('complex')<0) ? 'label' : 'statistic'
            statistics_ids.push({id: item.id, type: type})
            let index = this.setStatistics.findIndex(stat => stat.id===item.id)
            if(index<0){
              this.$store.dispatch('analytics_old/statistics/getData', {id: item.id, type: type, mode: 'graph', data: {} }).then( response => {
                let stat = response
                stat.type = type
                if(stat.lines.length>0) this.convertOutputSettings(stat.lines)
                this.setStatistics.push(stat)
              })
            }
          }
        })
        this.$store.dispatch('analytics_old/sets/saveStatistics', {id: this.selectedSet.id, statistics: statistics_ids})
        setTimeout( _ => {
          this.loading = false
        }, 500)
      },
  
      selectNode(item){
        if(item.element_type==='folder' && item.children){
          item.children.map( node => {
            if(node.element_type==='statistic') node.selected = item.selected
          })
        }
      }
    }
  }
</script>

<style scoped>
  .set__list-item .v-list__tile__action{
    min-width: 30px;
  }
  #set-context-menu ul.ctx-menu li{
    padding: 5px 6px 5px 4px;
    cursor: pointer;
    font-size: 14px;
  }
  #set-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #set-context-menu ul.ctx-menu li i{
    width: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Sets/Sets.vue